import useLanguage from "@casino/legacy/client/hooks/useLanguage";
import useSite from "@casino/legacy/client/hooks/useSite";
import type { LoginMutation } from "@workspace/casino_core/mutations/LoginMutation";
import { useLoginMutation } from "@workspace/casino_core/mutations/LoginMutation.client";
import { useState } from "react";
import useHandleFormCaptcha from "../../hooks/useHandleFormCaptcha";
import type FormValues from "../LoginBody/FormLogin/useFormLogin/FormValues";

type HandleLoginArgs = Omit<FormValues, "global">;

type Args = {
  captchaRequired: boolean;
};
const hasErrors = (data: LoginMutation | undefined, error?: unknown) =>
  error || data?.userManagementLoginViaPassword?.errors?.length;

const useLogin = ({ captchaRequired }: Args) => {
  const { handleFormCaptcha } = useHandleFormCaptcha(captchaRequired);
  const { code: language } = useLanguage();
  const [loading, setLoading] = useState(false);
  const { site } = useSite();
  const [login, { error }] = useLoginMutation();

  const handleLogin = async ({
    password,
    username,
    captcha,
    otp = "",
    uses2FA,
  }: HandleLoginArgs) => {
    setLoading(true);
    const { captchaToken, captchaVersion } = await handleFormCaptcha(captcha);

    const loginResult = await login({
      site,
      language,
      password,
      username,
      otp: uses2FA ? otp : undefined,
      captcha: captchaToken,
      captchaVersion,
      domain: window.location.hostname,
    });

    if (hasErrors(loginResult.data, error)) {
      setLoading(false);
    }
    return loginResult;
  };
  return { handleLogin, loading };
};

export default useLogin;
